import * as React from 'react';
import Provider from './Provider';
/**
 * This is a centralized App component that contains any Provides
 * or similar files needed for a Feature App development.
 * As such it's a placeholder for future improvements.
 * Everything in here should be rendered before any other Feature App code.
 * @param props Props to forward
 */
const App = (props) => (React.createElement(Provider, { ...props }));
export default App;
